/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../../../config.json";
import "../../../../../i18n";
import { useTranslation } from "react-i18next";

const Choices = ({ choice, fetchChoices }) => {
  const { t } = useTranslation();
  const { _id, choiceDetails = [], isArchived } = choice;

  const hideChoice = async () => {
    try {
      await axios.put(`${config.local}/v2/choices/hide/${_id}`).then(() => {
        swal("SUCCESS", "Choice is in hide mode", "success");
      });
      fetchChoices();
    } catch (error) {
      swal("ERROR", "" + error, "error");
    }
  };

  if (isArchived) return null;

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className="card kitchen-card">
        <div className="card-body">
          <div className="kitchen-card__top">
            <div className="kitchen-card__menu">
              <Dropdown>
                <Dropdown.Toggle
                  variant="outline-secondary"
                  className="btn-sm"
                  id="choice-actions"
                >
                  <i className="fas fa-ellipsis-v" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    as={Link}
                    to={`/choice-details/${_id}`}
                    className="text-secondary"
                  >
                    <i className="fas fa-eye me-2 text-secondary" />
                    {t("details")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    to={`/edit-choice/${_id}`}
                    className="text-warning"
                  >
                    <i className="fas fa-pen me-2 text-warning" />
                    {t("edit")}
                  </Dropdown.Item>
                  <Dropdown.Item onClick={hideChoice} className="text-danger-dark">
                    <i className="fas fa-archive me-2 text-danger-dark" />
                    {t("archive")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="kitchen-card__title text-center">
            <h4>
              <Link to="#">
                {choiceDetails.map((detail) =>
                  detail.language === "en" ? detail.choiceTitle : null
                )}
              </Link>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Choices;
